import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageConstants } from '../utils/constants/language.constants';

const NO_PREFIX_FALLBACK_LANGUAGES = ['zh'];

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(private translocoService: TranslocoService) {}

  initializeLanguage(): void {
    const detectLang = this.detectBrowserLanguage();
    this.setLanguage(detectLang);
    console.log('language: ', this.getActiveLanguage());
  }

  private detectBrowserLanguage(): string {
    const browserLang = navigator.language;

    if (LanguageConstants.SUPPORTED_LANGUAGE_CODES.includes(browserLang)) {
      return browserLang;
    }

    const baseLang = browserLang.split('-')[0];
    // Chinese variants differ by script (Simplified vs Traditional), so a prefix match would pick the wrong one.
    if (NO_PREFIX_FALLBACK_LANGUAGES.includes(baseLang)) {
      return LanguageConstants.DEFAULT_LANGUAGE_CODE;
    }
    const fallbackLang = LanguageConstants.SUPPORTED_LANGUAGE_CODES.find(
      (code) => code.startsWith(baseLang)
    );
    return fallbackLang || LanguageConstants.DEFAULT_LANGUAGE_CODE;
  }

  getSupportedLanguagesNames(): string[] {
    return LanguageConstants.SUPPORTED_LANGUAGE_NAMES;
  }

  getSupportedLanguageCodes(): string[] {
    return LanguageConstants.SUPPORTED_LANGUAGE_CODES;
  }

  getDefaultLanguage(): string {
    return LanguageConstants.DEFAULT_LANGUAGE_CODE;
  }

  isLanguageSupported(lang: string): boolean {
    if (!lang || typeof lang !== 'string') {
      return false;
    }
    return LanguageConstants.SUPPORTED_LANGUAGE_CODES.includes(lang);
  }

  doesLanguageRequireGender(lang: string): boolean {
    if (!lang || typeof lang !== 'string') {
      return false;
    }
    return LanguageConstants.GENDER_REQUIRED_LANGUAGES.includes(lang);
  }

  getSupportedLanguagesCode() {
    return LanguageConstants.SUPPORTED_LANGUAGE_CODES;
  }

  setLanguage(lang: string): void {
    if (!lang || typeof lang !== 'string') {
      console.warn('Invalid language parameter provided');
      this.translocoService.setActiveLang(
        LanguageConstants.DEFAULT_LANGUAGE_CODE
      );
      return;
    }

    if (this.isLanguageSupported(lang)) {
      this.translocoService.setActiveLang(lang);
    } else {
      console.warn(
        `Unsupported language: ${lang}, defaulting to '${LanguageConstants.DEFAULT_LANGUAGE_CODE}'`
      );
      this.translocoService.setActiveLang(
        LanguageConstants.DEFAULT_LANGUAGE_CODE
      );
    }
  }

  getActiveLanguage(): string {
    return this.translocoService.getActiveLang();
  }
}
